"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 14.9",
    width: "34",
    height: "14.9"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M31,11H3c-0.3,0-0.5-0.2-0.5-0.5v-10C2.5,0.2,2.7,0,3,0h28c0.3,0,0.5,0.2,0.5,0.5v10 C31.5,10.8,31.3,11,31,11z M3.5,10h27V1h-27V10z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M33.5,11h-3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5S33.8,11,33.5,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M3.5,11h-3C0.2,11,0,10.8,0,10.5S0.2,10,0.5,10h3C3.8,10,4,10.2,4,10.5S3.8,11,3.5,11z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11.5",
    y: "10.3",
    fill: "#9ECE06",
    width: "10.7",
    height: "1.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M22.2,12.4H11.5c-0.3,0-0.5-0.2-0.5-0.5v-1.6c0-0.3,0.2-0.5,0.5-0.5h10.7c0.3,0,0.5,0.2,0.5,0.5v1.6 C22.7,12.2,22.5,12.4,22.2,12.4z M12,11.4h9.7v-0.6H12V11.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M8.2,14.9c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S9.6,14.9,8.2,14.9z M8.2,10.9 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S9,10.9,8.2,10.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M3.8,14.9c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S5.2,14.9,3.8,14.9z M3.8,10.9 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S4.6,10.9,3.8,10.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M30,14.9c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S31.4,14.9,30,14.9z M30,10.9 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S30.8,10.9,30,10.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M25.6,14.9c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S27,14.9,25.6,14.9z M25.6,10.9 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S26.4,10.9,25.6,10.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M9,10.5c-0.3,0-0.5-0.2-0.5-0.5V6c0-0.3,0.2-0.5,0.5-0.5S9.5,5.7,9.5,6v4C9.5,10.3,9.3,10.5,9,10.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M25,10.5c-0.3,0-0.5-0.2-0.5-0.5V6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4C25.5,10.3,25.3,10.5,25,10.5z "
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#9ECE06",
    cx: "17.5",
    cy: "5.8",
    r: "2.7"
  }));
};

exports["default"] = _default;